var exports = {
  "n": "xfd349460--abb130--link",
};

module.exports = exports;
